
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiElectricGeneratorDc as ObiElectricGeneratorDcElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-electric-generator-dc.js';
 
 
 

 
 export const ObiElectricGeneratorDc = createComponent({
   react: React,
   tagName: 'obi-electric-generator-dc',
   elementClass: ObiElectricGeneratorDcElement,
   events: {
     
   }
  });
 
 